import React from "react";
import { salePrice, SALE_MAX, SALE_MIN } from "../sale";

function SaleFields({ data, setData, rate }) {
  const price = data.on_sale ? salePrice(rate, data.sale_discount) : null;

  return (
    <>
      <div className="form-group row">
        <label className="col-sm-3 col-form-label" htmlFor="on-sale-switch">
          On sale
        </label>
        <div className="col-sm-9 d-flex align-items-center">
          <input
            id="on-sale-switch"
            type="checkbox"
            role="switch"
            checked={!!data.on_sale}
            onChange={(e) => setData({ ...data, on_sale: e.target.checked })}
          />
        </div>
      </div>
      {data.on_sale && (
        <div className="form-group row">
          <label className="col-sm-3 col-form-label" htmlFor="sale-discount">
            Sale discount %<span className="required"> * </span>
          </label>
          <div className="col-sm-9">
            <div className="d-flex align-items-center">
              <input
                id="sale-discount"
                className="form-control"
                style={{ maxWidth: 140 }}
                type="number"
                min={SALE_MIN}
                max={SALE_MAX}
                step={1}
                value={data.sale_discount ?? ""}
                onWheelCapture={(e) => e.target.blur()}
                onChange={(e) => setData({ ...data, sale_discount: e.target.value })}
              />
              {price !== null && <b className="ml-3">Sale price: ₹{price}</b>}
            </div>
            <small className="text-muted">
              Leftover or near-expiry food, sold at this cut. The listed price stays the 'was' price. If a variant's
              offer is cheaper, customers pay the offer.
            </small>
          </div>
        </div>
      )}
    </>
  );
}

export default SaleFields;
